import { AppHeader } from "@package/ui-header";
import {
  setSliceDisplayFullWidth,
  useDispatchDisplay,
  useSelectorDisplay,
} from "@package/ui-redux";

export function Header() {
  const fullWidth = useSelectorDisplay((state) => state.display.fullWidth);
  const dispatch = useDispatchDisplay();

  return (
    <AppHeader
      isFullWidth={fullWidth}
      onFullWidthChanegd={(full) => dispatch(setSliceDisplayFullWidth(full))}
    />
  );
}
